<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
  .abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  .content {
    padding: 29px 40px;
  }
  .title-content {
    position: relative;
    h2 {
      float: left;
      line-height: 36px;
      font-size: 17px;
      font-weight: normal;
    }
    .filter-date-wrapper {
      float: right;
      padding-bottom: 8px;
      right: 0;
      font-size: 13px;
    }
  }
</style>

<template lang="pug">
  section.content
    .title-content
      h2 보너스 내역
      .filter-date-wrapper
        filter-date-range(
          :dateRange="dateRange",
          :downloadName="downloadName",
          :downloadUrl="downloadUrl",
          :download="download",
          @changeDate="changeQuery($event)",
          @excelDownload="excelDownload",
          @clearDownload="clearDownload",
        )

    div(v-loading="loading")
      el-table(v-if="!loading", :data="tableData", border, align="center", class="table-type-1")
        el-table-column(type="index", width="80", label="번호", align="center", :index="indexMethod")
        el-table-column(prop="paymentDate", label="지급일", align="center")
          p(slot-scope="scope") {{ scope.row.useDate | displayPaymentDate }}
        el-table-column(prop="bizPoint", label="보너스", align="center")
          p(slot-scope="scope") {{ scope.row.bizPoint | displayPrice }}
        el-table-column(prop="couponName", label="사유", header-align="center", align="left")
          p(slot-scope="scope") {{ scope.row.couponName }}
      .pager(v-if="!loading")
        el-pagination(
          background,
          layout="prev, pager, next",
          @current-change="paging",
          :page-size="ps",
          :total="rows",
          :current-page.sync="pg",
        )
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import FilterDateRange from '@/components/FilterDateRange.vue';

moment.locale('ko');
export default {
  name: 'Bizmoney',
  components: {
    FilterDateRange,
  },
  filters: {
    displayPaymentDate(value) {
      return moment(value).format('YYYY.MM.DD');
    },
    displayPrice(value) {
      let result = value;
      if (value === undefined) {
        result = 0;
      }
      return `${result.toLocaleString()}₩`;
    },
    displayTax(value) {
      return `${Math.round(value * 0.1).toLocaleString()}₩`;
    },
    displayState(value) {
      return (value === 'Y') ? '완료' : '대기';
    },
  },
  computed: {
    ...mapState({
      query: state => state.route.query,
    }),
  },
  async mounted() {
    if (this.query.startday !== undefined) {
      this.dateRange = [
        moment(this.query.startday, 'YY-MM-DD'),
        moment(this.query.endday, 'YY-MM-DD'),
      ];
    }
    this.paging(1);
  },
  methods: {
    // 날짜 변경
    changeQuery(value) {
      const { path } = this.$route;
      const query = { ...this.$route.query };

      query.startday = moment(value[0]).format('YY-MM-DD');
      query.endday = moment(value[1]).format('YY-MM-DD');
      this.dateRange = [...value];

      this.$router.replace({ path, query });
      this.paging(1);
    },

    // 페이징
    async paging(value) {
      const { path } = this.$route;
      const query = { ...this.$route.query };
      query.pg = value;

      this.pg = value;
      this.loading = true;
      const [startDate, endDate] = this.dateRange;
      const ssd = moment(startDate).format('YYYY-MM-DD');
      const sed = moment(endDate).format('YYYY-MM-DD');
      const list = await this.$http.get('/api/mkc/v1/bizpoint-coupons', {
        params: {
          ps: this.ps,
          pg: this.pg,
          ssd,
          sed,
        },
      });
      this.tableData = list.data.data;
      this.rows = list.data.meta.total;
      this.loading = false;

      this.$router.replace({ path, query });
      window.scrollTo(0, 0);
    },

    // 엑셀 다운로드
    async excelDownload() {
      const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
      const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
      const list = await this.$http.get('/api/mkc/v1/bizpoint-coupons', {
        params: {
          ps: this.rows,
          pg: 1,
          ssd: startDate,
          sed: endDate,
        },
      });

      const excelList = [];
      list.data.data.forEach((v) => {
        excelList.push([
          moment(v.useDate).format('YYYY.MM.DD'),
          `="${v.bizPoint}"`,
          v.couponName,
        ]);
      });

      const header = ['\uFEFF지급일', '보너스', '사유'].join(',');
      const csv = ['data:text/csv;charset=utf-8', [header, ...excelList].join('\r\n')].join(',');
      this.downloadUrl = encodeURI(csv);
      this.downloadName = `${startDate}_${endDate}_보너스내역.csv`;

      this.download = true;
    },

    clearDownload() {
      this.downloadName = null;
      this.downloadUrl = null;
      this.download = false;
    },

    // 게시물 번호
    indexMethod(index) {
      return (this.rows - (this.pg - 1) * this.ps) - index;
    },
  },
  data() {
    return {
      rows: 0,
      pg: 1,
      ps: 10,

      downloadUrl: null,
      downloadName: null,
      download: false,

      dateRange: [
        moment().subtract(3, 'month'),
        moment(),
      ],

      // 테이블 데이터
      tableData: [],
      loading: false,
    };
  },
};
</script>
